import React, { useState, useEffect } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import facultyAPI from "../api/facultyApi";

const Faculty = () => {
  const [facultyInfo, setFacultyInfo] = useState([]);

  useEffect(() => {
    fetchFaculty();
  }, []);

  const fetchFaculty = async () => {
    const res = await facultyAPI.faculty();

    if (res.code === 200) {
      const result = res.data;

      setFacultyInfo(result?.["our-faculty"]);
    }
  };
  const info = facultyInfo?.[0];

  return (
    <>
      <BreadCrumbBanner
        title="Faculty"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <div>
        {/* about teachers section */}
        {info && ( 
          <section className="faculty-intro-unique py-5">
            <div className="container">
              <div className="row align-items-stretch g-3">
                <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center animate__animated animate__fadeInLeft">
                  <div className="intro-text-box h-100 p-4 p-md-4">
                    <div className="header-group mb-4">
                      <span className="trust-badge">{info.title}</span>{" "}
                      <h2 className="fw-bold text-primary-mrv m-0">
                        {info.name}
                      </h2>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: info.description }}
                    />
                  </div>
                </div>

                <div className="col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0">
                  <div className="faculty-img-wrapper h-100 position-relative animate__animated animate__fadeInRight">
                    <img
                      src={info.image} 
                      alt="Faculty Introduction"
                      className="img-fluid h-100 w-100 faculty-main-img"
                      loading="lazy"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default Faculty;
